import * as types from '../constants';

export function loadGlobalFeeds() {
  return {
    type: types.LOAD_GLOBAL_FEEDS,
  };
}

export function loadFeedsGlobal() {
  return {
    type: types.LOAD_FEEDS_GLOBAL,
  };
}

export function loadNewFeedsGlobal() {
  return {
    type: types.LOAD_NEW_FEEDS_GLOBAL,
  };
}

export function consumeFeedData(data) {
  return {
    type: types.CONSUME_FEED_DATA,
    data,
  };
}

export function consumeFileData(data) {
  return {
    type: types.CONSUME_FILE_DATA,
    data,
  };
}

export function createVirtualFeed(data) {
  return {
    type: types.CREATE_VIRTUAL_FEED,
    data,
  };
}

export function updateVirtualFeed(data) {
  return {
    type: types.UPDATE_VIRTUAL_FEED,
    data,
  };
}

export function verifyAuth(data) {
  return {
    type: types.VERIFY_FEED_AUTH,
    data,
  };
}

export function createGlobalFeed(data) {
  return {
    type: types.CREATE_GLOBAL_FEED,
    data,
  };
}

export function updateGlobalFeed(data) {
  return {
    type: types.UPDATE_GLOBAL_FEED,
    data,
  };
}

export function deleteGlobalFeed(feed) {
  return {
    type: types.DELETE_GLOBAL_FEED,
    feed,
  };
}

export function resetFeedStatus() {
  return {
    type: types.RESET_FEED_STATUS,
  };
}

export function loadFeeds() {
  return {
    type: types.LOAD_FEEDS,
  };
}

export function loadAllFeeds() {
  return {
    type: types.LOAD_ALL_FEEDS,
  };
}

export function loadNewFeeds() {
  return {
    type: types.LOAD_NEW_FEEDS,
  };
}

export function createCollectionByFileUpload(data, originator) {
  return {
    type: types.CREATE_COLLECTION_BY_FILE_UPLOAD,
    data,
    originator,
  };
}

export function createCollectionByURLUpload(data, originator) {
  return {
    type: types.CREATE_COLLECTION_BY_URL_UPLOAD,
    data,
    originator,
  };
}

export function loadCollections() {
  return {
    type: types.LOAD_COLLECTIONS,
  };
}

export function loadOrganizationCollections() {
  return {
    type: types.LOAD_ORGANIZATION_COLLECTIONS,
  };
}

export function loadOrganizationFeeds() {
  return {
    type: types.LOAD_ORGANIZATION_FEEDS,
  };
}

export function loadNewOrganizationFeeds() {
  return {
    type: types.LOAD_NEW_ORGANIZATION_FEEDS,
  };
}

export function loadMyCollections() {
  return {
    type: types.LOAD_MY_COLLECTIONS,
  };
}

export function loadMyFeeds() {
  return {
    type: types.LOAD_MY_FEEDS,
  };
}

export function loadNewMyFeeds() {
  return {
    type: types.LOAD_NEW_MY_FEEDS,
  };
}

export function loadFeedPerformance() {
  return {
    type: types.LOAD_FEED_PERFORMANCE,
  };
}

export function clearSourcesReports() {
  return {
    type: types.CLEAR_SOURCES_REPORTS,
  };
}

export function loadSourcesReports(feed_type, sources_uuids) {
  return {
    type: types.LOAD_SOURCES_REPORTS,
    feed_type,
    sources_uuids,
  };
}

export function loadSourceReport(feed_uuid, sources_uuids) {
  return {
    type: types.LOAD_SOURCE_REPORT,
    feed_uuid,
    sources_uuids,
  };
}

export function saveEmptyCollection(data) {
  return {
    type: types.SAVE_EMPTY_COLLECTION,
    data,
  };
}

export function updateFeed(data) {
  return {
    type: types.UPDATE_FEED,
    data,
  };
}

export function shareCollection(data) {
  return {
    type: types.SHARE_COLLECTION,
    data,
  };
}

export function updateCollection(data, originator) {
  return {
    type: types.UPDATE_COLLECTION,
    data,
    originator,
  };
}

export function changeScopeCollection(data, originator) {
  return {
    type: types.CHANGE_SCOPE_COLLECTION,
    data,
    originator,
  };
}

export function publishCollection(data) {
  return {
    type: types.PUBLISH_COLLECTION,
    data,
  };
}

export function uploadToCollection(data, originator) {
  return {
    type: types.UPLOAD_TO_COLLECTION,
    data,
    originator,
  };
}

export function simpleAddFeed() {
  return {
    type: types.SIMPLE_ADD_FEED,
  };
}

export function deleteEmptyFeed() {
  return {
    type: types.DELETE_EMPTY_FEED,
  };
}

export function createFeed(data) {
  return {
    type: types.CREATE_FEED,
    data,
  };
}

export function deleteFeed(uuid) {
  return {
    type: types.DELETE_FEED,
    uuid,
  };
}

export function deleteMyFeed(uuid) {
  return {
    type: types.DELETE_MY_FEED,
    uuid,
  };
}

export function deleteOrganizationFeed(uuid) {
  return {
    type: types.DELETE_ORGANIZATION_FEED,
    uuid,
  };
}

export function exportFeed(uuid) {
  return {
    type: types.EXPORT_FEED,
    uuid,
  };
}

export function deleteCollection(uuid) {
  return {
    type: types.DELETE_COLLECTION,
    uuid,
  };
}

export function loadCollection(uuid) {
  return {
    type: types.LOAD_COLLECTION,
    uuid,
  };
}

export function activateCollection(data) {
  return {
    type: types.ACTIVATE_COLLECTION,
    data,
  };
}

export function activateFeed(data) {
  return {
    type: types.ACTIVATE_FEED,
    data,
  };
}

export function activateMyFeed(data) {
  return {
    type: types.ACTIVATE_MY_FEED,
    data,
  };
}

export function activateOrganizationFeed(data) {
  return {
    type: types.ACTIVATE_ORGANIZATION_FEED,
    data,
  };
}

export function loadAvailableFeeds() {
  return {
    type: types.LOAD_AVAILABLE_FEEDS,
  };
}

export function loadIPEditableFeeds(state) {
  return {
    type: types.LOAD_IP_EDITABLE_FEEDS,
    state,
  };
}

export function loadDomainEditableFeeds(state) {
  return {
    type: types.LOAD_DOMAIN_EDITABLE_FEEDS,
    state,
  };
}

export function loadURLEditableFeeds(state) {
  return {
    type: types.LOAD_URL_EDITABLE_FEEDS,
    state,
  };
}
